module.exports = __webpack_public_path__ + "img/visa.0a066639.png";